// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Step5_wrapper__6dik8","uploads":"Step5_uploads__1mMHk","gdpr":"Step5_gdpr__5NjDZ"};